<template>
    <div class="d-flex justify-space-between align-center">
        <router-link :to="{ name: 'NovaArvore' }">
            <v-btn color="primary"
                ><v-icon>mdi-family-tree</v-icon
                ><span class="pl-2">Nova Árvore</span></v-btn
            >
        </router-link>
        <v-text-field
            style="border: 0px solid green"
            append-icon="mdi-magnify"
            dense
            hide-details
            placeholder="Procurar Árvore"
            class="ml-4 flex-grow-1"
            filled
            @input="textoBusca"
            :value="filtro"
        >
        </v-text-field>
        <v-select
            :items="['Lançadas', 'Desabilitadas', 'Todas']"
            :value="lancadas"
            filled
            dense
            hide-details
            full-width
            class="ml-4 flex-grow-0"
            style="border: 0px solid red; min-width: 400px"
            @change="lancadaEscolhido"
        ></v-select>
    </div>
</template>

<script>
export default {
    name: "Controles",
    data() {
        return {
            filtro: this.filtroInicial,
            debounceTimeout: null,
        };
    },
    props: {
        filtroInicial: { required: true, default: "" },
        lancadas: { required: true },
    },
    methods: {
        lancadaEscolhido(evt) {
            this.$emit("lancadaEscolhido", evt);
        },
        textoBusca(evt) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => {
                this.$emit("textoBusca", evt);
            }, 300);
        },
    },
};
</script>
